import {
  useBoxLockIframe,
  UseBoxLockIframeEventData,
  withBoxPaywallFrameBusID,
} from '@jusbrasil-web/shared-feature-locker-farol'
import { RefObject } from 'react'

import { BOX_PAYWALL_IFRAME_URL } from '../constants'

export interface UseBoxPaywallProps {
  eventData: UseBoxLockIframeEventData
  ref: RefObject<HTMLElement>
  defaultOpen?: boolean
  enabled?: boolean
}

// See libs/docview/core/src/components/view-lock-wrapper/view-lock-wrapper.module.scss
export const MIN_HEIGHT_FALLBACK = 300 // px

// It will be used when the iframe does not support ResizeObserver, so we need to set a fixed value
export const NO_SUPPORTED_HEIGHT_FALLBACK = 750 // px. Last seen value (with 150 more) in devtools inspector (2024-07-08)

export const useBoxPaywall = (resourceId: string, props: UseBoxPaywallProps) => {
  const { eventData, ref, enabled: enabledProp, defaultOpen = false } = props

  const enabled = enabledProp && !!ref.current

  const frameId = withBoxPaywallFrameBusID(resourceId)
  const frameUrl = `${BOX_PAYWALL_IFRAME_URL}?resourceId=${resourceId}`

  return useBoxLockIframe(
    frameId,
    frameUrl,
    { ...eventData, isPaywall: true },
    {
      prefetch: enabled,
      closeOnReconnect: false,
      closeOnPopstate: false,
      frameBus: {
        iframeMode: 'INLINE',
        enabled,
        defaultOpen,
        container: ref.current || undefined,
        listeners: {
          resize: (data = {}) => {
            if (!ref.current) return

            if ('error' in data) {
              switch (data.error) {
                case 'NOT_SUPPORTED':
                  ref.current.style.setProperty('height', `${NO_SUPPORTED_HEIGHT_FALLBACK}px`)
                  break
              }
              return
            }

            const height = data?.height
            if (!height || height < MIN_HEIGHT_FALLBACK) return
            ref.current.style.setProperty('height', `${height}px`)
          },
        },
      },
    }
  )
}
